/**
 * Swiper for PDP media gallery (main + thumbs). Requires swiper-bundle.min.js + media-gallery custom element.
 */
(function () {
  const ATTR = 'data-product-media-swiper';

  function whenSwiper(cb) {
    if (window.Swiper) {
      cb();
      return;
    }
    let n = 0;
    const t = setInterval(() => {
      n += 1;
      if (window.Swiper) {
        clearInterval(t);
        cb();
      } else if (n > 50) {
        clearInterval(t);
      }
    }, 80);
  }

  function thumbDirection() {
    return window.matchMedia('(min-width: 750px)').matches ? 'vertical' : 'horizontal';
  }

  function isThumbsShellVisible(shell) {
    if (!shell) return false;
    const style = window.getComputedStyle(shell);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    return shell.getClientRects().length > 0;
  }

  function pruneEmptySlides(mainEl) {
    mainEl.querySelectorAll('.swiper-slide').forEach((slide) => {
      const hasMedia = slide.querySelector(
        '.product__media img, .product__media video, .product__media iframe, .product__media model-viewer, .deferred-media'
      );
      if (!hasMedia) slide.remove();
    });
  }

  function destroyGallery(mg) {
    if (mg._embeThumbResize) window.removeEventListener('resize', mg._embeThumbResize);
    mg._embeMainSwiper?.destroy?.(true, true);
    mg._embeThumbSwiper?.destroy?.(true, true);
    mg._embeMainSwiper = null;
    mg._embeThumbSwiper = null;
    mg.removeAttribute('data-swiper-ready');
  }

  function initGallery(mg) {
    if (!mg.hasAttribute(ATTR)) return;

    const mainEl = mg.querySelector('.product-media-gallery__swiper--main');
    if (!mainEl) return;

    whenSwiper(() => {
      destroyGallery(mg);

      pruneEmptySlides(mainEl);

      const mainSlides = mainEl.querySelectorAll('.swiper-slide');
      if (!mainSlides.length) return;

      const viewer = mg.querySelector('[id^="GalleryViewer"]');
      const thumbsShell = mg.querySelector('.product-media-gallery__thumbs-shell');
      const thumbsRoot = thumbsShell?.querySelector('.product-media-gallery__swiper--thumbs');
      const thumbSlides = thumbsRoot ? thumbsRoot.querySelectorAll('.swiper-slide') : [];
      const thumbsPrev = thumbsShell?.querySelector('.product-media-gallery__thumbs-nav--prev');
      const thumbsNext = thumbsShell?.querySelector('.product-media-gallery__thumbs-nav--next');

      const canUseThumbs =
        isThumbsShellVisible(thumbsShell) &&
        thumbsRoot &&
        thumbSlides.length > 0 &&
        thumbSlides.length === mainSlides.length;

      let thumbSwiper = null;
      if (canUseThumbs) {
        thumbSwiper = new window.Swiper(thumbsRoot, {
          direction: thumbDirection(),
          speed: 380,
          slidesPerView: 5,
          spaceBetween: 10,
          slidesPerGroup: 1,
          freeMode: false,
          resistance: true,
          resistanceRatio: 0.85,
          watchOverflow: true,
          watchSlidesProgress: true,
          watchSlidesVisibility: true,
          centerInsufficientSlides: true,
          roundLengths: true,
          observer: true,
          observeParents: true,
          navigation:
            thumbsPrev && thumbsNext
              ? {
                  prevEl: thumbsPrev,
                  nextEl: thumbsNext,
                }
              : undefined,
        });
        mg._embeThumbSwiper = thumbSwiper;

        const onResize = () => {
          if (!thumbSwiper || thumbSwiper.destroyed) return;
          const next = thumbDirection();
          if (thumbSwiper.params.direction !== next) {
            thumbSwiper.changeDirection(next);
          }
          thumbSwiper.update();
        };
        mg._embeThumbResize = onResize;
        window.addEventListener('resize', onResize, { passive: true });
      }

      const paginationEl = mainEl.querySelector('.swiper-pagination');
      const mainSwiper = new window.Swiper(mainEl, {
        speed: 480,
        spaceBetween: 0,
        watchOverflow: true,
        autoHeight: false,
        roundLengths: true,
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        keyboard: { enabled: true, onlyInViewport: true },
        navigation: {
          nextEl: mainEl.querySelector('.swiper-button-next'),
          prevEl: mainEl.querySelector('.swiper-button-prev'),
        },
        pagination: paginationEl
          ? {
              el: paginationEl,
              type: 'fraction',
              clickable: true,
            }
          : undefined,
        thumbs: thumbSwiper ? { swiper: thumbSwiper } : undefined,
        on: {
          slideChange(sw) {
            sw.slides.forEach((slide, i) => {
              slide.classList.toggle('is-active', i === sw.activeIndex);
            });
            const slide = sw.slides[sw.activeIndex];
            if (viewer && slide) {
              viewer.dispatchEvent(
                new CustomEvent('slideChanged', {
                  bubbles: true,
                  detail: {
                    currentPage: sw.activeIndex + 1,
                    currentElement: slide,
                  },
                })
              );
            }
          },
        },
      });

      mg._embeMainSwiper = mainSwiper;
      mg.setAttribute('data-swiper-ready', '1');

      const initial = mainEl.querySelector('.swiper-slide.is-active') || mainEl.querySelector('.swiper-slide');
      if (initial) {
        const idx = [...mainSwiper.slides].indexOf(initial);
        if (idx >= 0) mainSwiper.slideTo(idx, 0);
      }

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          mainSwiper.update();
          thumbSwiper?.update?.();
          if (mainSwiper.pagination) mainSwiper.pagination.update();
        });
      });
    });
  }

  function scan(root) {
    root.querySelectorAll(`media-gallery[${ATTR}]`).forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan(document));
  } else {
    scan(document);
  }

  document.addEventListener('product-info:loaded', (e) => {
    if (!e?.target) return;
    requestAnimationFrame(() => scan(e.target));
  });

  document.addEventListener('shopify:section:load', (e) => scan(e.target));

  document.addEventListener('shopify:section:unload', (e) => {
    e.target.querySelectorAll(`media-gallery[${ATTR}]`).forEach(destroyGallery);
  });

  window.embeInitProductMediaGalleries = scan;
})();
